import uuid from 'uuid';

class Message {
  constructor(msg) {
    // not sure what else we want here, but we will probably want tracking and other details eventually
    const newMessage = messages(msg);
    this.messageType = newMessage.messageType;
    this.text = newMessage.text;
    this.messageId = uuid();
    this.caller = msg;
  }
}

// TODO this should look up the language translations for errors
const messages = msg => {
  switch (msg) {
    case 'getActivityError':
      return {
        messageType: 'error',
        text: 'error getting activity',
      };
    case 'trackInProcess':
      return {
        messageType: 'warning',
        text: 'the uploaded track is being processed, this might take a second or two',
      };
    case 'errorProcessingTrack':
      return {
        messageType: 'error',
        text: `processing of a track has failed and it cannot be played`,
      };

    case 'noStartPoint':
      return {
        messageType: 'error',
        text: 'error getting activity for this scene',
      };
    default:
      return {
        messageType: 'error',
        text: 'an unknown error occured',
      };
  }
};

export { Message as default };
